(function () {
  'use strict';

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var gallery = {
    stage: null,
    main: null,
    thumbs: [],
    current: 0,

    init: function () {
      this.stage = q('.gallery-stage');
      if (!this.stage) return;
      this.current = 0;
      this.main = q('.main-image img', this.stage);
      this.refresh();
      var self = this;
      var left = q('.thumbnail-arrow--left', this.stage);
      var right = q('.thumbnail-arrow--right', this.stage);
      if (left) left.addEventListener('click', function () { self.step(-1); });
      if (right) right.addEventListener('click', function () { self.step(1); });
    },

    refresh: function () {
      this.thumbs = qa('.thumbnail-strip button', this.stage);
      var self = this;
      this.thumbs.forEach(function (btn, idx) {
        btn.addEventListener('click', function () { self.setActive(idx); });
      });
    },

    step: function (delta) {
      this.setActive(this.current + delta);
    },

    setActive: function (i) {
      if (!this.thumbs.length) return;
      this.current = (i + this.thumbs.length) % this.thumbs.length;
      this.thumbs.forEach(function (btn, idx) {
        btn.classList.toggle('active', idx === gallery.current);
        btn.setAttribute('aria-pressed', String(idx === gallery.current));
      });
      var img = q('img', this.thumbs[this.current]);
      var src = img && img.getAttribute('src');
      if (this.main && src) {
        this.main.setAttribute('src', src);
        this.main.classList.add('is-loaded');
      }
      if (this.thumbs[this.current] && this.thumbs[this.current].scrollIntoView) {
        this.thumbs[this.current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    },

    setImages: function (list) {
      var strip = q('.thumbnail-strip', this.stage);
      if (!strip) return;
      strip.innerHTML = '';
      list.forEach(function (src, idx) {
        var btn = document.createElement('button');
        if (idx === 0) btn.className = 'active';
        btn.setAttribute('aria-label', 'View product image ' + (idx + 1));
        btn.setAttribute('aria-pressed', String(idx === 0));
        var img = document.createElement('img');
        img.alt = '';
        img.src = src;
        btn.appendChild(img);
        strip.appendChild(btn);
      });
      this.current = 0;
      this.refresh();
      if (this.main && list[0]) {
        this.main.setAttribute('src', list[0]);
        this.main.classList.add('is-loaded');
      }
    }
  };

  function initOptions() {
    var select = q('.cubeflex-variant-select');
    var priceEl = q('[data-price]');
    var compareEl = q('[data-compare-price]');
    var addPrice = q('[data-add-cart-price]');
    var mainWrap = q('.main-image');

    var LAYOUT_CLASSES = {
      '2 Seater': 'two',
      'Chaise Sofa': 'chaise-left',
      'Corner Sofa': 'chaise-right',
      'Lounge Sofa': 'lounge',
      'Extended Lounge': 'extended',
      'Grand Lounge': 'grand'
    };

    function readColorGallery() {
      var mapEl = q('#cubeflex-gallery-map');
      if (!mapEl) return {};
      try { return JSON.parse(mapEl.textContent); } catch (e) { return {}; }
    }
    var colorGallery = readColorGallery();
    var hasExplicitConfiguration = new URLSearchParams(window.location.search).has('cf_config');

    function configurationUrl(url) {
      var target = new URL(url, window.location.origin);
      target.searchParams.set('cf_config', '1');
      var previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewTheme) target.searchParams.set('preview_theme_id', previewTheme);
      return target.pathname + target.search + target.hash;
    }

    function selectedValues() {
      var vals = ['', '', ''];
      qa('.option-block').forEach(function (block) {
        var btn = q('button.selected, button.active', block);
        if (btn) {
          var idx = parseInt(btn.getAttribute('data-option-index'), 10);
          vals[idx] = btn.getAttribute('data-value');
        }
      });
      return vals;
    }

    function applyVariant() {
      if (!select) return;
      var vals = selectedValues();
      var target = null;
      qa('option', select).forEach(function (o) {
        if (
          o.getAttribute('data-option1') === vals[1] &&
          o.getAttribute('data-option2') === vals[2]
        ) {
          target = o;
        }
      });
      if (!target) return;
      select.value = target.value;
      if (priceEl) priceEl.textContent = target.getAttribute('data-price');
      if (addPrice) addPrice.textContent = target.getAttribute('data-price');
      if (compareEl) {
        var cp = target.getAttribute('data-compare-at-price');
        if (cp) {
          compareEl.textContent = cp;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function applyImage() {
      var vals = selectedValues();
      var color = vals[1] || 'Dark Grey';
      var list = colorGallery[color];
      if (list && list.length) gallery.setImages(list);
      var configBtn = q('.config-option button.selected');
      var layoutKey = configBtn ? configBtn.getAttribute('data-layout-key') : vals[0];
      var layoutClass = LAYOUT_CLASSES[layoutKey] || 'chaise-right';
      if (mainWrap) {
        mainWrap.classList.remove(
          'product-image-two',
          'product-image-chaise-left',
          'product-image-chaise-right',
          'product-image-lounge',
          'product-image-extended',
          'product-image-grand'
        );
        mainWrap.classList.add('product-image-' + layoutClass);
      }
    }

    function setInitialOption(blockSelector, value, activeClass) {
      var block = q(blockSelector);
      if (!block) return;
      var buttons = qa('button', block);
      var target = null;
      buttons.forEach(function (btn) {
        if (btn.getAttribute('data-value') === value || btn.getAttribute('data-layout-key') === value) target = btn;
      });
      if (!target) return;
      buttons.forEach(function (btn) {
        btn.classList.remove('selected', 'active');
        btn.setAttribute('aria-pressed', 'false');
      });
      target.classList.add('selected');
      if (activeClass) target.classList.add(activeClass);
      target.setAttribute('aria-pressed', 'true');
      var title = q('[data-option-title]', block);
      if (title) title.textContent = target.getAttribute('data-value') || target.getAttribute('aria-label') || value;
    }

    function applyInitialDefaults() {
      if (!hasExplicitConfiguration) setInitialOption('.config-option', 'Corner Sofa');
      setInitialOption('.color-option', 'Dark Grey');
      setInitialOption('.material-option', 'Chenille', 'active');
    }

    function openDefaultConfiguration() {
      if (hasExplicitConfiguration) return false;
      var defaultButton = q('.config-option .layout-3[data-config-url]');
      var defaultUrl = defaultButton && defaultButton.getAttribute('data-config-url');
      if (!defaultUrl) return false;
      var currentPath = window.location.pathname.replace(/\/$/, '');
      var defaultPath = new URL(defaultUrl, window.location.origin).pathname.replace(/\/$/, '');
      if (currentPath === defaultPath) return false;
      window.location.replace(configurationUrl(defaultUrl));
      return true;
    }
    function updateAvailability() {
      if (!select) return;
      var vals = selectedValues();
      var material = vals[2];
      var colorButtons = qa('.color-option button[data-option-index="1"]');
      if (!colorButtons.length) return;
      var available = {};
      qa('option', select).forEach(function (o) {
        if (o.getAttribute('data-option2') === material) {
          available[o.getAttribute('data-option1')] = true;
        }
      });
      colorButtons.forEach(function (btn) {
        var ok = !!available[btn.getAttribute('data-value')];
        btn.classList.toggle('is-unavailable', !ok);
      });
      var current = q('.color-option button.selected');
      if (current && current.classList.contains('is-unavailable')) {
        current.classList.remove('selected');
        current.setAttribute('aria-pressed', 'false');
        var first = null;
        for (var i = 0; i < colorButtons.length; i++) {
          if (!colorButtons[i].classList.contains('is-unavailable')) { first = colorButtons[i]; break; }
        }
        if (first) {
          first.classList.add('selected');
          first.setAttribute('aria-pressed', 'true');
          var title = q('.color-option [data-option-title]');
          if (title) title.textContent = first.getAttribute('data-value');
        }
      }
    }

    qa('.option-block').forEach(function (block) {
      var title = q('[data-option-title]', block);
      var buttons = qa('button', block);
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          var configUrl = btn.getAttribute('data-config-url');
          buttons.forEach(function (b) {
            b.classList.remove('selected', 'active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('selected', 'active');
          btn.setAttribute('aria-pressed', 'true');
          var label = btn.getAttribute('data-value') || btn.getAttribute('aria-label') || btn.textContent.trim();
          if (title) title.textContent = label;
          if (configUrl) {
            if (e) e.preventDefault();
            navigateProduct(configurationUrl(configUrl));
            return;
          }
          updateAvailability();
          applyVariant();
          applyImage();
        });
      });
    });
    function refreshOptions() {
      colorGallery = readColorGallery();
      updateAvailability();
      applyVariant();
      applyImage();
    }

    window.__cubeflexRefreshOptions = refreshOptions;
    applyInitialDefaults();
    if (openDefaultConfiguration()) return;
    refreshOptions();
  }

  function initQuantity() {
    var root = q('.quantity-control');
    if (!root) return;
    var out = q('span', root);
    var input = q('input', root);
    function set(n) {
      n = Math.max(1, Math.min(99, n));
      if (out) out.textContent = String(n);
      if (input) input.value = String(n);
    }
    qa('button', root).forEach(function (btn, idx) {
      btn.addEventListener('click', function () {
        var cur = parseInt((out && out.textContent) || '1', 10) || 1;
        set(idx === 0 ? cur - 1 : cur + 1);
      });
    });
  }

  function initRecommendations() {
    var root = q('.recommendation-carousel');
    if (!root) return;
    var cards = q('.product-cards', root);
    var prev = q('.recommendation-arrow--previous', root);
    var next = q('.recommendation-arrow--next', root);
    if (!cards) return;
    function updateRecommendationArrows() {
      var max = cards.scrollWidth - cards.clientWidth;
      if (prev) prev.disabled = cards.scrollLeft <= 1;
      if (next) next.disabled = cards.scrollLeft >= max - 1;
    }
    if (next) next.addEventListener('click', function () { cards.scrollBy({ left: cards.clientWidth, behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { cards.scrollBy({ left: -cards.clientWidth, behavior: 'smooth' }); });
    cards.addEventListener('scroll', updateRecommendationArrows, { passive: true });
    updateRecommendationArrows();
  }

  function initReviews() {
    var tabs = qa('.review-tabs button');
    var reviews = q('#reviews-panel');
    var faq = q('#faq-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var isFaq = tab.id === 'faq-tab';
        if (reviews) reviews.style.display = isFaq ? 'none' : '';
        if (faq) faq.style.display = isFaq ? '' : 'none';
      });
    });
  }

  function initReviewPagination() {
    var panel = q('#reviews-panel');
    if (!panel) return;
    var items = qa('article[data-review-page]', panel);
    var dots = qa('.review-dot', panel);
    if (!items.length || !dots.length) return;
    function show(page) {
      var target = String(page);
      items.forEach(function (el) {
        el.style.display = el.getAttribute('data-review-page') === target ? '' : 'none';
      });
      dots.forEach(function (d) {
        var isActive = d.getAttribute('data-review-page') === target;
        d.classList.toggle('active', isActive);
        if (isActive) {
          d.setAttribute('aria-current', 'true');
        } else {
          d.removeAttribute('aria-current');
        }
      });
    }

    function scrollToFirstReview(page) {
      var target = String(page);
      var firstReview = null;
      items.forEach(function (el) {
        if (!firstReview && el.getAttribute('data-review-page') === target) firstReview = el;
      });
      if (!firstReview) return;

      window.requestAnimationFrame(function () {
        var header = q('.site-header');
        var headerOffset = (header ? header.getBoundingClientRect().height : 0) + 20;
        var top = firstReview.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var page = parseInt(d.getAttribute('data-review-page'), 10);
        show(page);
        scrollToFirstReview(page);
      });
    });
    show(1);
  }

  function initVideo() {
    var hero = q('.video-hero');
    if (!hero) return;

    function hydrateVideo(video) {
      if (video.dataset.cubeflexSourceReady === 'true') return;
      qa('source[data-src]', video).forEach(function (source) {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
      });
      video.dataset.cubeflexSourceReady = 'true';
    }

    function startVideo(video) {
      hydrateVideo(video);
      video.muted = true;
      video.loop = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function startVisibleVideos() {
      qa('video', hero).forEach(function (video) {
        if (window.getComputedStyle(video).display !== 'none') startVideo(video);
      });
    }

    function preloadDesktopVideo() {
      var video = q('.video-hero-desktop', hero);
      if (!video || window.getComputedStyle(video).display === 'none') return;
      video.preload = 'auto';
      hydrateVideo(video);
      video.load();
    }

    function scheduleDesktopPreload() {
      function queuePreload() {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(preloadDesktopVideo, { timeout: 2200 });
        } else {
          window.setTimeout(preloadDesktopVideo, 1200);
        }
      }

      if (document.readyState === 'complete') queuePreload();
      else window.addEventListener('load', queuePreload, { once: true });
    }

    if (!('IntersectionObserver' in window)) {
      startVisibleVideos();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        startVisibleVideos();
        observer.disconnect();
      });
    }, { rootMargin: '900px 0px' });
    observer.observe(hero);
    scheduleDesktopPreload();
  }

  function initGalleryPin() {
    var media = window.matchMedia('(min-width: 821px)');

    function syncGalleryPin() {
      var stage = q('.gallery-stage');
      var wrap = q('.gallery-sticky-wrap');
      var spacer = q('.gallery-spacer');
      var story = q('.product-story');
      if (!stage || !wrap || !spacer || !story) return;

      if (!media.matches) {
        stage.style.removeProperty('--gallery-pin-top');
        wrap.style.removeProperty('--gallery-pin-extension');
        return;
      }

      var scrollTop = window.scrollY || window.pageYOffset || 0;
      var galleryTop = wrap.getBoundingClientRect().top + scrollTop;
      var storyTop = story.getBoundingClientRect().top + scrollTop;
      var releaseAt = galleryTop + stage.offsetHeight + 110;
      var fixedDistance = Math.max(0, storyTop - releaseAt);
      var extension = Math.max(0, fixedDistance - spacer.offsetHeight);

      stage.style.setProperty('--gallery-pin-top', Math.round(galleryTop) + 'px');
      wrap.style.setProperty('--gallery-pin-extension', Math.round(extension) + 'px');
    }

    window.__cubeflexSyncGalleryPin = syncGalleryPin;
    syncGalleryPin();

    if (!window.__cubeflexGalleryPinBound) {
      window.addEventListener('resize', function () {
        if (window.__cubeflexSyncGalleryPin) window.__cubeflexSyncGalleryPin();
      });
      window.__cubeflexGalleryPinBound = true;
    }
  }

  function reinit() {
    gallery.init();
    initOptions();
    initQuantity();
    initRecommendations();
    initReviews();
    initReviewPagination();
    initVideo();
    initGalleryPin();
  }

  function reinitProductSection() {
    gallery.init();
    initOptions();
    initQuantity();
    initGalleryPin();
  }

  var configurationCache = {};
  var pendingConfiguration = null;

  function configurationCacheKey(url) {
    var target = new URL(url, window.location.origin);
    target.search = '';
    target.hash = '';
    return target.pathname;
  }

  function primeConfigurationCache() {
    var data = q('#cubeflex-configuration-data');
    if (!data) return;
    try {
      var payloads = JSON.parse(data.textContent);
      Object.keys(payloads).forEach(function (url) {
        var payload = payloads[url];
        if (payload && payload.title && payload.variants && payload.gallery) {
          configurationCache[configurationCacheKey(url)] = payload;
        }
      });
    } catch (error) {
      console.error('Unable to read CubeFlex configuration data.', error);
    }
  }

  function cubeflexPageUrl(url) {
    var target = new URL(url, window.location.origin);
    target.searchParams.set('view', 'cubeflex');
    return target.pathname + target.search + target.hash;
  }

  function setConfigurationLoading(isLoading) {
    qa('.config-option button[data-config-url]').forEach(function (button) {
      button.disabled = isLoading;
      button.setAttribute('aria-busy', String(isLoading));
    });
  }

  function fetchConfiguration(url) {
    var key = configurationCacheKey(url);
    if (configurationCache[key]) return Promise.resolve(configurationCache[key]);

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = url + sep + 'view=cubeflex-config';
    return fetch(fetchUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('bad status');
        return response.json();
      })
      .then(function (payload) {
        if (!payload || !payload.title || !payload.variants || !payload.gallery) throw new Error('invalid configuration payload');
        configurationCache[key] = payload;
        return payload;
      })
      .catch(function () {
        var legacyUrl = cubeflexPageUrl(url);
        return fetch(legacyUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (response) {
            if (!response.ok) throw new Error('bad status');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextSection = doc.querySelector('.cubeflex-product');
            var nextProductSection = nextSection && q('.product-section', nextSection);
            if (!nextProductSection) throw new Error('missing product section');
            var payload = {
              html: nextProductSection.outerHTML,
              title: doc.title
            };
            configurationCache[key] = payload;
            return payload;
          });
      });
  }

  function replaceProductSection(payload) {
    var holder = document.createElement('div');
    holder.innerHTML = payload.html;
    var nextProductSection = q('.product-section', holder);
    var currentProductSection = q('.product-section');
    if (!nextProductSection || !currentProductSection) throw new Error('missing product section');
    currentProductSection.replaceWith(nextProductSection);
    if (payload.title) document.title = payload.title;
    reinitProductSection();
  }

  function applyConfigurationPayload(payload) {
    var title = q('#product-title');
    var galleryMap = q('#cubeflex-gallery-map');
    var select = q('.cubeflex-variant-select');
    var mainImage = q('.main-image img');

    if (title) title.textContent = payload.title;
    if (payload.documentTitle) document.title = payload.documentTitle;
    if (galleryMap) galleryMap.textContent = JSON.stringify(payload.gallery);
    if (mainImage) mainImage.alt = (payload.selected.color || 'Dark Grey') + ' U-Shaped Modular Couch product view';

    if (select) {
      select.innerHTML = '';
      payload.variants.forEach(function (variant) {
        var option = document.createElement('option');
        option.value = String(variant.id);
        option.selected = String(variant.id) === String(payload.selected.id);
        option.setAttribute('data-price', variant.price || '');
        option.setAttribute('data-compare-at-price', variant.compareAtPrice || '');
        option.setAttribute('data-option1', variant.option1 || '');
        option.setAttribute('data-option2', variant.option2 || '');
        option.setAttribute('data-option3', variant.option3 || '');
        option.textContent = [variant.option1, variant.option2, variant.option3].filter(Boolean).join(' / ');
        select.appendChild(option);
      });
    }

    if (window.__cubeflexRefreshOptions) window.__cubeflexRefreshOptions();
    if (window.__cubeflexSyncGalleryPin) window.__cubeflexSyncGalleryPin();
  }

  function navigateProduct(url) {
    var key = configurationCacheKey(url);
    if (pendingConfiguration === key) return;

    pendingConfiguration = key;
    setConfigurationLoading(true);
    fetchConfiguration(url)
      .then(function (payload) {
        if (payload.html) {
          replaceProductSection(payload);
        } else {
          applyConfigurationPayload(payload);
        }
        history.pushState({}, '', cubeflexPageUrl(url));
      })
      .catch(function (error) {
        console.error('Unable to update CubeFlex configuration.', error);
      })
      .finally(function () {
        pendingConfiguration = null;
        setConfigurationLoading(false);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    primeConfigurationCache();
    gallery.init();
    initOptions();
    initQuantity();
    initRecommendations();
    initReviews();
    initReviewPagination();
    initVideo();
    initGalleryPin();
  });
})();
